import {
  RequestInspectionStorePayload,
} from '../models';
import { RequestInspection } from '../models/requestInspection.model';
import { RequestStatus } from '../models/enums';

const buildCreatePayload = (payload: RequestInspectionStorePayload): RequestInspection => ({
    contactFirstName: payload.contactFirstName,
    contactLastName: payload.contactLastName,
    companyName: payload.companyName,
    phone: payload.contactPhone,
    fax: payload.contactFax,
    contactRole: JSON.stringify(payload.contactRole),
    email: payload.contactEmail,
    projectName: payload.projectName,
    qcpProjectNumber: payload.qcpProjectNumber,
    reasonForRequest: payload.requestReason,
    inspectionType: JSON.stringify(payload.inspectionType),
    status: RequestStatus.Pending,
  });


export default {
  buildCreatePayload,
};